<template>
    <b-media
        class="text-muted text-truncate cursor-pointer"
        vertical-align="center"
        @click="redirect(notification.log_event.operation)"
    >
        <avatar :size="35" :src="iconTargetOutline" slot="aside" />
        <b-row no-gutters>
            <b-col cols="12">
                <h6 class="font-weight-bold">
                    {{ getTitle(notification.log_event.operation) }}
                </h6>
            </b-col>
            <b-col cols="12">
                <p class="custom-text mb-0">
                    {{ getDescription(notification.log_event.operation, notification.log_event) }}
                </p>
            </b-col>
            <b-col>
                <div class="text-right">
                    <small>{{ createdAt }}</small>
                </div>
            </b-col>
        </b-row>
    </b-media>
</template>
<script>
import i18n from '@/i18n'
import moment from 'moment'
import Avatar from 'vue-avatar'
import iconTargetOutline from '@/assets/images/icon_target_outline.png'
import { toV1 } from '@/router/routesToV1'

export default {
    name: 'Notification',
    components: {
        Avatar,
    },
    props: ['notification'],
    data() {
        return {
            iconTargetOutline: iconTargetOutline,
        }
    },
    methods: {
        getTitle(operation) {
            const { log_event } = this.notification
            const artifactType = log_event.artifact_type

            const operationTitleMap = {
                goal_suggestion: i18n.t('form.label.targetLibrary'),
                unblock_checkin: i18n.t('checkIn.checkInReleased'),
                comment: i18n.t('form.label.comment'),
                update: {
                    objective: i18n.t('form.label.objective'),
                    key_result: i18n.t('keyResult.keyResult'),
                    initiative: i18n.t('daily.initiative'),
                    checkin: i18n.t('calculation.checkinType.checkin'),
                },
                create: {
                    objective: i18n.t('form.label.objective'),
                    key_result: i18n.t('keyResult.keyResult'),
                    initiative: i18n.t('daily.initiative'),
                    checkin: i18n.t('calculation.checkinType.checkin'),
                },
                create_kr_checkin: i18n.t('calculation.checkinType.checkin'),
            }

            if (operationTitleMap.hasOwnProperty(operation)) {
                if (operationTitleMap[operation][artifactType]) {
                    return operationTitleMap[operation][artifactType]
                } else {
                    return operationTitleMap[operation]
                }
            }
        },
        getDescription(operation, logEvent) {
            const { indicator, key_result, objective } = logEvent
            let title = ''
            let initiativeTitle = ''

            const isObjective = logEvent.artifact_type === 'objective'
            const isKR = logEvent.artifact_type === 'key_result'
            const isInitiative = logEvent.artifact_type === 'initiative'
            const isCheckin = logEvent.artifact_type === 'checkin'
            const isGoal = logEvent.artifact_type === 'goal'

            switch (operation) {
                case 'goal_suggestion':
                case 'unblock_checkin':
                case 'comment':
                    if (isGoal) {
                        title = indicator.title
                    } else if (isKR) {
                        title = key_result.title
                    } else if (isObjective) {
                        title = objective.title
                    }
                    return i18n.t(`notification.description.${operation}.${logEvent.artifact_type}`, { title })
                case 'create':
                case 'update':
                    if (isObjective) {
                        title = objective.title
                        return i18n.t(`notification.description.${operation}.${logEvent.artifact_type}`, { title })
                    } else if (isKR) {
                        title = key_result.title
                        return i18n.t(`notification.description.${operation}.${logEvent.artifact_type}`, { title })
                    } else if (isInitiative) {
                        title = key_result.title

                        key_result.initiatives.forEach((initiatives) => {
                            if (initiatives.id == logEvent.initiative_id) {
                                initiativeTitle = initiatives.title
                            }
                        })

                        return i18n.t(`notification.description.${operation}.${logEvent.artifact_type}`, {
                            title,
                            initiativeTitle,
                        })
                    } else if (isCheckin) {
                        title = key_result.title
                        return i18n.t(`notification.description.${logEvent.artifact_type}`, { title })
                    }

                case 'create_kr_checkin':
                    title = key_result.title
                    return i18n.t(`notification.description.${logEvent.artifact_type}`, { title })

                default:
                    break
            }
        },
        redirect(operation) {
            const isObjective = this.notification.log_event.artifact_type === 'objective'
            const isKR = this.notification.log_event.artifact_type === 'key_result'
            const isCheckin = this.notification.log_event.artifact_type === 'checkin'
            const isInitiative = this.notification.log_event.artifact_type === 'initiative'
            const isGoal = this.notification.log_event.artifact_type === 'goal'

            switch (operation) {
                case 'goal_suggestion':
                    return this.$router.push({
                        path: `/v2/profile/${this.notification.receiver_id}?activeTab=hiringGoals`,
                    })

                case 'unblock_checkin':
                case 'comment':
                    if (isObjective) {
                        return toV1('/okr/objectives', {
                            objectiveId: this.notification.log_event.objective.id,
                        })
                    } else if (isKR) {
                        return toV1('/okr/objectives/key-results', {
                            objectiveId: this.notification.log_event.objective.id,
                            keyResultId: this.notification.log_event.key_result.id,
                        })
                    } else if (isGoal) {
                        return this.$router.push({
                            path: `/v2/target/targets/view/${this.notification.log_event.indicator.id}`,
                        })
                    }

                case 'create':
                case 'update':
                    if (isObjective) {
                        return toV1('/okr/objectives', {
                            objectiveId: this.notification.log_event.objective.id,
                        })
                    } else if (isKR || isCheckin) {
                        return toV1('/okr/objectives/key-results', {
                            objectiveId: this.notification.log_event.objective.id,
                            keyResultId: this.notification.log_event.key_result.id,
                        })
                    } else if (isInitiative) {
                        return this.$router.push({
                            path: `/v2/profile/${this.notification.receiver_id}?activeTab=myInitiatives`,
                        })
                    }

                case 'create_kr_checkin':
                    return toV1('/okr/objectives/key-results', {
                        objectiveId: this.notification.log_event.objective.id,
                        keyResultId: this.notification.log_event.key_result.id,
                    })
            }
        },
    },
    computed: {
        createdAt() {
            return moment(this.notification.created_at).fromNow()
        },
    },
}
</script>

<style scoped>
.font-weight-bold {
    font-weight: 700 !important;
}

.custom-text {
    text-align: justify;
    white-space: normal;
    text-overflow: ellipsis;
}
</style>
